<section class="terms-hero">
  <div class="overlay">
    <h1>Conditions Générales d’Utilisation</h1>
    <p>Nos règles qui encadrent l’utilisation de notre plateforme afin de garantir un espace bienveillant, sécurisé et respectueux.</p>
  </div>
</section>

<section class="terms-content container">
  <div class="terms-block">
    <h2>🔐 Données et confidentialité</h2>
    <p>Nous nous engageons à protéger vos données personnelles. Celles-ci ne sont ni vendues ni partagées à des tiers sans votre consentement explicite.</p>
  </div>

  <div class="terms-block">
    <h2>✅ Utilisation du contenu</h2>
    <p>Les contenus publiés sur AfroTech Hub (articles, vidéos, visuels, etc.) sont protégés. Vous êtes libre de les partager avec attribution, mais toute utilisation à des fins commerciales est strictement interdite sans autorisation préalable.</p>
  </div>

  <div class="terms-block">
    <h2>🙅‍♂️ Comportement des utilisateurs</h2>
    <p>Tout comportement abusif, propos haineux ou tentative de piratage entraînera la suspension immédiate du compte concerné.</p>
  </div>

  <div class="terms-block">
    <h2>🚨 Suspension de compte</h2>
    <p>AfroTech Hub se réserve le droit de suspendre ou de supprimer tout compte ne respectant pas les présentes conditions d’utilisation.</p>
  </div>

  <div class="terms-block">
    <h2>📩 Contact</h2>
    <p>
      Pour toute question, vous pouvez nous écrire à
      <a href="mailto:contact@afrotech-hub.com">contact@afrotech-hub.com</a>
      ou utiliser notre <a routerLink="/contact">formulaire de contact</a>.
    </p>
  </div>
</section>
